import { render } from "./TEditor.vue?vue&type=template&id=8b00c4ca"
import script from "./TEditor.vue?vue&type=script&lang=js"
export * from "./TEditor.vue?vue&type=script&lang=js"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__